// Eksplisitte runtime-bindinger mellom domenefilene og backend-fasaden.
var {
  projectTimeApi,
  emitProjectsChanged,
  getProjectTimeModel,
  resolveProjectCustomer,
  saveProjectRecord,
  deleteProjectRecord,
  saveProjectActivity,
  deleteProjectActivity,
  saveTimeEntry,
  deleteTimeEntry,
  saveTimeTrackingSettings,
  buildTimeEntryInvoiceDraft,
  createInvoiceDraftFromTimeEntries,
  releaseTimeEntriesFromInvoice,
} = globalThis.PlummeBackendProjects;

var {
  isLegacyDesignQuoteLine,
  normalizeCustomerConversationThread,
  createCustomerConversationThread,
  replaceCustomerLocal,
  conversationsCollection,
  conversationCloudReady,
  sortConversationThreads,
  buildConversationSummary,
  sameConversationSummary,
  syncConversationSummary,
  clearLegacyConversationThreads,
  migrateCustomerConversationThreadsToCloud,
  persistCleanedDesignFixtureLines,
  loadCustomerConversationThreads,
  moveCustomerConversationThreads,
  saveCustomerConversationThread,
  sendCustomerConversationEmail,
  createOfferFromCustomerConversation,
} = globalThis.PlummeBackendCustomerConversations;
